@if (form.controls["from"] && form.controls["to"]) {
  <ng-container *transloco="let t">
    <fieldset [formGroup]="form">
      <div class="row">
        @if (invalidRanges && (ranges?.from || ranges?.to) && (this.form.touched || displayRangeErrorBeforeTouched)) {
          <div>
                <span class="errorMes">
                    {{
                    t(invalidMessageKey,
                      {
                        startDate: ranges?.from | localizedDate:'shortDate',
                        startTime: ranges?.from ?? '' | localizedDate:'shortTime',
                        endDate: ranges?.to | localizedDate:'shortDate',
                        endTime: ranges?.to | localizedDate:'shortTime'
                      })
                  }}
                </span>
          </div>
        }
        <div class="col-md-6 pb-3 pb-xl-0" (click)="form.controls['from'].markAsTouched()">
          <app-date-time-input formControlName="from" [displayTime]="displayTime"
                               [label]="labelStart"
                               [maxDate]="fromCalendarAvailableDates.to"
                               [minDate]="fromCalendarAvailableDates.from ?? calendarStart"
                               [hideErrorMessage]="invalidRanges && (!!ranges?.from || !!ranges?.to)"/>
        </div>
        <div class="col-md-6 pb-3 pb-xl-0" (click)="form.controls['from'].markAsTouched()">
          <app-date-time-input [label]="labelEnd"
                               formControlName="to"
                               [displayTime]="displayTime" [maxDate]="toCalendarAvailableDates.to"
                               [minDate]="toCalendarAvailableDates.from ?? calendarStart"
                               [hideErrorMessage]="invalidRanges && (!!ranges?.from || !!ranges?.to)"/>
        </div>
      </div>
    </fieldset>
  </ng-container>
}
